module.exports = __webpack_public_path__ + "img/one.046ab51f.png";